<template>
  <button class="sidebar-minimizer brand-minimizer" type="button" @click="toogleStorage"></button>
</template>

<script>
import EventBus from '../../EventBus';
export default {
  mounted () {
    this.addMinimizedClass();
  },
  methods: {
    toogleStorage () {
      if (localStorage.getItem("sidebarMinimized")) {
        localStorage.removeItem("sidebarMinimized");
          EventBus.$emit('SIDE_BAR_EXPANDED');
      } else {
          localStorage.setItem("sidebarMinimized", true);
          EventBus.$emit('SIDE_BAR_MINIMIZED');
      }
    },
    addMinimizedClass () {
      if (localStorage.getItem("sidebarMinimized")) {
        document.body.classList.add("brand-minimized", "sidebar-minimized")
      }
    }
  }
}
</script>
